import { memo, useState } from 'react';
import { View, StyleSheet, Text, Dimensions } from 'react-native';
import I18n from '../../../I18n';
import CTAButton from '../cta_button';
import { THEME, FONT, FONT_SIZE, COLOR, __WEB__ } from '../../../constants/styles';

export default memo(function Footer(props) {
  const { width } = Dimensions.get('window');
  const [vertical, setVertical] = useState(width < 440);

  const renderVertical = vertical && !props.forceHorizontal;

  function renderVerticalChildren() {
    if (!props.children) return null;
    return <View style={styles.childrenContainerVertical}>{props.children}</View>;
  }

  function renderHorizontalChildren() {
    if (!props.children) return null;
    return <View style={styles.childrenContainerHorizontal}>{props.children}</View>;
  }

  function handleLayoutChange({ nativeEvent }) {
    if (!nativeEvent?.layout?.width) return;
    const newVertical = nativeEvent.layout.width < 440;
    if (vertical !== newVertical) setVertical(newVertical);
  }

  function renderCancel() {
    if (!props.onCancel) return null;
    return (
      <CTAButton
        autoFocus={!!props.autoFocus && !props.onSave && !props.onReject}
        label={props.cancelLabel || I18n.c1('cancel')}
        style={[
          renderVertical ? styles.buttonVertical : null,
          props.cancelBtnStyle,
          renderVertical ? props.buttonVerticalStyle : null,
        ]}
        styleType="secondary"
        onPress={props.onCancel}
        disabled={props.cancelDisabled}
      />
    );
  }
  function renderSave() {
    if (!props.onSave) return null;
    return (
      <CTAButton
        autoFocus={!!props.autoFocus}
        label={props.saveLabel || I18n.c1('save')}
        style={[
          renderVertical ? styles.buttonVertical : styles.buttonHorizontal,
          props.saveBtnStyle,
          renderVertical ? props.buttonVerticalStyle : props.buttonHorizontalStyle,
        ]}
        styleType="main"
        onPress={props.onSave}
        disabled={props.saveDisabled}
        renderSpinner={props.renderSpinner}
        testID="saveButton"
      />
    );
  }

  return (
    <View
      style={[
        renderVertical ? styles.footerVertical : styles.footer,
        renderVertical && !!props.children ? { paddingTop: 20 } : null,
        renderVertical ? props.verticalStyle : props.horizontalStyle,
      ]}
      onLayout={handleLayoutChange}
    >
      {!!renderVertical && renderVerticalChildren()}
      {props.reverseOrder ? renderSave() : renderCancel()}
      {!renderVertical && !props.children && <View style={{ flex: 1 }} />}
      {!renderVertical && renderHorizontalChildren()}
      {!!props.onReject && (
        <CTAButton
          autoFocus={!!props.autoFocus && !props.onSave}
          label={props.rejectLabel || I18n.c1('reject')}
          style={[
            vertical ? styles.buttonVertical : styles.buttonHorizontal,
            props.rejectBtnStyle,
            vertical ? props.buttonVerticalStyle : null,
          ]}
          styleType="main"
          onPress={props.onReject}
          disabled={props.rejectDisabled}
        />
      )}
      {!!props.onNext && (
        <CTAButton
          label={props.nextLabel || 'Next'}
          style={[
            vertical ? styles.buttonVertical : styles.buttonHorizontal,
            props.rejectBtnStyle,
            vertical ? props.buttonVerticalStyle : null,
          ]}
          styleType="secondary"
          onPress={props.onNext}
          disabled={props.nextDisabled}
        />
      )}
      {props.reverseOrder ? renderCancel() : renderSave()}
    </View>
  );
});

const styles = StyleSheet.create({
  footer: {
    ...THEME.basicRow,
    ...THEME.borderTop,
    paddingHorizontal: 30,
    paddingVertical: 30,
    backgroundColor: COLOR.altContrast,
  },
  footerVertical: {
    ...THEME.borderTop,
    paddingHorizontal: 30,
    paddingVertical: 30,
    backgroundColor: COLOR.altContrast,
  },
  cancelButton: {
    backgroundColor: COLOR.contrast,
    borderWidth: 1.5,
    borderColor: '#ddd',
  },
  buttonVertical: {
    width: '100%',
    marginBottom: 20,
  },
  buttonHorizontal: {
    width: 'auto',
    paddingHorizontal: 35,
    marginLeft: 15,
  },
  childrenContainerHorizontal: {
    flex: 1,
  },
  childrenContainerVertical: {
    minHeight: 50,
    paddingBottom: 20,
  },
  btnText: __WEB__
    ? {
        ...FONT.regular,
        fontSize: 16,
      }
    : {
        ...FONT.medium,
        fontSize: 18,
      },
});
